import React, { Component, type ReactNode } from "react";
import { Alert } from "reactstrap";
import ExceptionFormatter from "src/shared/formatters/ExceptionFormatter";
import DetailedMessage, {
  MessageEnum,
  type MessageType,
} from "src/shared/messages/objects/DetailedMessage";

export type Message = MessageType | DetailedMessage;

export interface IMessagesProps {
  messages: Message[] | Message;
  onHideMessage?: (message: Message) => void;
}

export default class Messages extends Component<IMessagesProps> {
  private isEmpty(): boolean {
    const { messages } = this.props;

    if (messages instanceof Array && messages.length === 0) {
      return true;
    } else if (!messages && typeof messages !== "number") {
      return true;
    }

    return false;
  }

  public render(): ReactNode {
    if (this.isEmpty()) {
      return null;
    }

    const { messages } = this.props;
    let messageArray: Message[];

    if (!(messages instanceof Array)) {
      messageArray = [messages];
    } else {
      messageArray = messages;
    }

    const { onHideMessage } = this.props;

    return (
      <>
        {messageArray.map((message: Message, index) => {
          return (
            <IndividualMessage
              key={index}
              message={message}
              onHideMessage={onHideMessage}
            />
          );
        })}
      </>
    );
  }
}

interface IIndividualMessageProps {
  message: Message;
  onHideMessage?: (message: Message) => void;
}

class IndividualMessage extends Component<IIndividualMessageProps> {
  constructor(props: IIndividualMessageProps) {
    super(props);

    this.onHideMessage = this.onHideMessage.bind(this);
  }

  private onHideMessage(): void {
    const { message, onHideMessage = null } = this.props;
    if (onHideMessage !== null) {
      onHideMessage(message);
    }
  }

  private getEnum(): MessageEnum {
    const { message } = this.props;
    if (message instanceof Error) {
      return MessageEnum.ERROR;
    } else if (message instanceof DetailedMessage) {
      return message.messageEnum;
    } else {
      return MessageEnum.INFO;
    }
  }

  private renderMessage(messageBody: Message): ReactNode | string {
    let message: MessageType;

    if (messageBody instanceof DetailedMessage) {
      message = messageBody.message;
    } else {
      message = messageBody;
    }

    if (message instanceof Error) {
      return <ExceptionFormatter exception={message} />;
    } else {
      return message;
    }
  }

  public render(): ReactNode {
    const messageEnum: MessageEnum = this.getEnum();
    const { message } = this.props;
    return (
      <Alert color={messageEnum.color} onClick={this.onHideMessage}>
        <i className={`fas fa-${messageEnum.fa}`} />{" "}
        {this.renderMessage(message)}
      </Alert>
    );
  }
}
